import { Delivery } from "../models/Delivery";
import PlotAPI from "../plotAPI";

interface useDeliveriesProps {
    projectInfo: (projectId: string | number) => any | null;
}

const useDeliveries = ({ projectInfo }: useDeliveriesProps) => {
    const createDelivery = (newDelivery: Delivery): Promise<Delivery | null> => {
        if (!newDelivery.projectId) {
            return Promise.resolve(null);
        }

        const project = projectInfo(newDelivery.projectId);

        if (!project) {
            return Promise.resolve(null);
        }

        return PlotAPI.createDelivery(
            project.claimed_by_team_subdomain || "projects",
            project.unique_token,
            newDelivery
        );
    };

    const updateDelivery = (updatedDelivery: Delivery) => {
        if (!updatedDelivery.projectId) {
            return Promise.resolve(null);
        }

        const project = projectInfo(updatedDelivery.projectId);

        if (!project) {
            return Promise.resolve(null);
        }

        return PlotAPI.updateDelivery(
            project.claimed_by_team_subdomain || "projects",
            project.unique_token,
            updatedDelivery
        );
    };

    const deleteDelivery = (deliveryToDelete: Delivery): Promise<boolean> => {
        if (!deliveryToDelete.projectId) {
            return Promise.resolve(false);
        }

        const project = projectInfo(deliveryToDelete.projectId);

        if (!project) {
            return Promise.resolve(false);
        }

        return PlotAPI.deleteDelivery(
            project.claimed_by_team_subdomain || "projects",
            project.unique_token,
            deliveryToDelete
        );
    };

    return {
        createDelivery,
        updateDelivery,
        deleteDelivery,
    };
};

export default useDeliveries;
